import { TagIcon, Truncate } from "@theprelude/ds";
import { DefaultTooltip } from "./default-tooltip";

const defaultExcess: never[] = [];

function Tag({
  tag,
  excess = defaultExcess,
}: {
  tag: string;
  excess?: string[];
}) {
  return (
    <div className="inline-flex min-w-0 items-center gap-1 rounded-xl border border-stroke-line px-2 py-1 text-secondary-foreground text-xs">
      <TagIcon />
      <Truncate text={tag}>
        <span className="text-primary-foreground">{tag}</span>
      </Truncate>
      {excess.length > 0 && (
        <DefaultTooltip
          asChild
          content={
            <div className="flex flex-col items-start gap-1">
              {excess.map((e) => (
                <span key={e} className="inline-flex items-center gap-1">
                  <TagIcon className="text-secondary-foreground" />
                  {e}
                </span>
              ))}
            </div>
          }
        >
          <span className="cursor-default">+{excess.length}</span>
        </DefaultTooltip>
      )}
    </div>
  );
}

export function Tags({
  tags,
  limit = tags.length,
}: {
  tags: string[];
  limit?: number;
}) {
  if (tags.length === 0) {
    return null;
  }

  const firstTags = tags.slice(0, limit - 1);
  const lastTag = tags[limit - 1];
  const excessTags = tags.slice(limit);

  return (
    <div className="flex min-w-0 items-center gap-1">
      {firstTags.map((tag) => (
        <Tag key={tag} tag={tag} />
      ))}
      {lastTag && <Tag tag={lastTag} excess={excessTags} />}
    </div>
  );
}
